import { UserFormAction } from "./action";
import { UserFormState, userFormState } from "./state";

export function UserFormReducer(
    state: UserFormState = userFormState,
    action: UserFormAction
): UserFormState {
    switch (action.type) {
        case "@@UserForm/inputUsernameAction":
            return {
                ...state,
                username: action.username,
            };
        case "@@UserForm/inputPasswordAction":
            console.log("action", action);
            return {
                ...state,
                password: action.password,
            };
        case "@@UserForm/inputRepeatPasswordAction":
            console.log("action", action);
            return {
                ...state,
                repeatPassword: action.repeatPassword,
            };
        case "@@UserForm/changeRoleAction":
            return {
                ...state,
                role: action.role,
            };
        case "@@UserForm/inputFormEmailAction":
            console.log("action", action);
            return {
                ...state,
                email: action.email,
            };
        case "@@UserForm/inputFormTruckAction":
            return {
                ...state,
                truck: action.truck,
            };

        case "@@UserForm/clearInputFormAction":
            return {
                ...state,
                username: "",
                password: "",
                role: "",
                email: "",
                truck: "",
                repeatPassword: "",
                selectedUser: false,
            };

        case "@@UserForm/initUserList":
            return {
                ...state,
                userList: action.userList,
            };

        case "@@UserForm/selectedEditUserAction":
            return {
                ...state,
                username: action.userData.username,
                role: action.userData.role_id,
                email: action.userData.email,
                truck: action.userData.truck,
                status: action.userData.status,
                selectedUser: true,
                user_id: action.userData.user_id,
            };

        case "@@UserForm/selectedUserStatusAction":
            return {
                ...state,
                status: action.status,
            };

        default:
            return state;
    }
}
